import React, {Component} from "react";
import './ColourBox.css';
import CopyToClipboard from "react-copy-to-clipboard";

class ColourBox extends Component{
    constructor(props){
        super(props);
        this.state=({
            copied: false
        });
        this.copyClick = this.copyClick.bind(this);
    }

    copyClick(){
        this.setState({copied:true},() => {
        setTimeout (() => this.setState({copied:false}),1500);
    });
}
    render(){
        const {name,background} = this.props;
        const {copied} = this.state;
        return(
            <CopyToClipboard text = {background} onCopy={this.copyClick}>
            <div style= {{background}}  className="ColourBox">
                <div style={{background}} className={`copy-overlay ${copied && "show"}`}/>
                <div className={`copy-msg ${copied && "show"}`}>
                    <h1>Copied!</h1>
                    <p>{background}</p>
                </div>
                <div className="copy-container">
                <div className="ColourBox-name">
                    <span>{name}</span>
                </div>
                    <button className="copy-button">Copy</button>
                </div>
                  
                    {/* <span className="ColourBox-more">MORE</span> */}
                
                
            </div>
            </CopyToClipboard>
            
        )
    }
}
export default ColourBox;